import { ClientesComponent } from './../clientes/clientes.component';
import { Component, Input, ViewChild, OnInit, EventEmitter, forwardRef, Provider, AfterViewInit,
  ElementRef, ComponentRef, Type, Output } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { Observable, fromEvent } from 'rxjs';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LookupData, AdvancedLookupComponent } from '../../models/lookup';
import { debounceTime, switchMap } from 'rxjs/operators';
import { ControlValueAccessor } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-control-lookup',
  templateUrl: './control-lookup.component.html',
  styleUrls: ['./control-lookup.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: ControlLookupComponent,
    multi: true
  }]
})
export class ControlLookupComponent implements OnInit, ControlValueAccessor, AfterViewInit  {
  @ViewChild('lookupId', { static: true }) lookupIdControl: ElementRef;
  @ViewChild('lookupText', { static: true }) lookupTextControl: ElementRef;
  @Input() disabled: boolean = false;
  @Input() labelText: string = "";
  @Input() parentForm!: FormGroup;
  @Input() fieldName!: string;
  @Output() isOptionSelected = new EventEmitter<boolean>();

  public serviceSource: (query: string) => Observable<LookupData>;
  public serviceSourceById: (id: number) => Observable<LookupData>;


  lookupControl: FormControl;
  lookupData = new LookupData();

  serviceLookupData: Observable<LookupData>;
  public advancedLookupComponent: Type<AdvancedLookupComponent>;

  public showAdvancedLookup: boolean;
  isLookup: boolean;

  constructor(private _dialog: MatDialog, private _sharedService: SharedService) {
    this.lookupControl = new FormControl();


  }

  changeObservable: Observable<Event>;

  ngAfterViewInit() {

    this.changeObservable = fromEvent(this.lookupTextControl.nativeElement, 'input');

    this.serviceLookupData =
      this.changeObservable.pipe(
        debounceTime(400),
        switchMap(value => {
          return this.serviceSource(this.lookupTextControl.nativeElement.value);
        })
      );
  }

  onEnter(event) {
    this.lookupTextControl.nativeElement.value = '';
  }
  onBlur(event) {
    this.lookupTextControl.nativeElement.value = this.lookupData.getDisplayText();
  }

  ngOnInit() {
    this.lookupControl.setValue(this.lookupData);

  }

  clearValue(event) {
    this.writeValue('');
    this._fillName();
    this.sendChange();
    this.isOptionSelected.emit(true);
  }

  onAdvancedLookup(event) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '95%';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.data = {
      component: this.advancedLookupComponent,
      isModal: true
    };

    this.isLookup = true;
    this._sharedService.emitBoolValue(this.isLookup);

    const ref = this._dialog.open(DialogComponent, dialogConfig);

    ref.afterClosed().subscribe(result => {
      this.isLookup = !this.isLookup;
      this._sharedService.emitBoolValue(this.isLookup);
      if (result === true) {
        const cInstance = ref.componentInstance.componentRef.instance;
        const id = cInstance.getSelectedItem();
        console.log(result);
        console.log(id);
        
        console.log(ref);
        if (id !== null) {
          this.writeValue(id);
          this.sendChange();
          this.isOptionSelected.emit();
          this._fillName();
        }
      }
    });
  }


  // the method set in registerOnChange, it is just
  // a placeholder for a method that takes one parameter,
  // we use it to emit changes back to the form
  private propagateChange = (_: any) => { };

  _fillName(): void {
    console.log(this.lookupData)
    if (this.lookupData.id !== undefined && this.lookupData.id != null) {
      if (this.lookupData.nameLoaded === false) {
        if (this.lookupData.id != null) {
          this.serviceSourceById(this.lookupData.id).subscribe(data => {
            this.lookupData.name = data.name;
            this.lookupData.nameLoaded = true;
            this.lookupTextControl.nativeElement.value = this.lookupData.getDisplayText();
          });
        }
      } else {
        this.lookupTextControl.nativeElement.value = this.lookupData.getDisplayText();
      }
    } else {
      this.lookupData = new LookupData();
      this.lookupTextControl.nativeElement.value = '';

    }
  }

  // this is the initial value set to the component
  public writeValue(obj: any) {

    this.lookupData = new LookupData();
    if (obj !== undefined && obj !== '') {
      this.lookupData.id = obj;
      this.lookupData.name = '(loading...)';
      this._fillName();
    }
  }

  // registers 'fn' that will be fired when changes are made
  // this is how we emit the changes back to the form
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  // not used, used for touch input
  registerOnTouched() { }

  // change events from the textarea
  sendChange() {
    // update the form
    this.propagateChange(this.lookupData.id);

  }

  fnDisplay(obj: LookupData): string {
    if (obj != null && obj.id !== undefined) {

      this.lookupData = new LookupData();
      this.lookupData.copyFrom(obj);
      const str = this.lookupData.getDisplayText();
      return str;
    } else {
      return '';
    }
  }


  selectionChange(event) {

    this.lookupData = new LookupData();
    this.lookupData.copyFrom(event.option.value);

    this.sendChange();
    this.isOptionSelected.emit(true);
    this._fillName();

  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
